// Stepper — sequência de segmentos. Cada step "preenchido" se index <= currentStep.
import type { HTMLAttributes } from 'react';
import styles from './Stepper.module.css';
import { cn } from '@/lib/utils/cn';

export interface StepperProps extends HTMLAttributes<HTMLDivElement> {
  /** índice (0-based) do passo atual */
  current: number;
  /** total de passos */
  total: number;
  label?: string;
}

export function Stepper({ current, total, label, className, ...rest }: StepperProps) {
  const steps = Array.from({ length: total }, (_, i) => i);
  return (
    <div
      className={cn(styles.stepper, className)}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={Math.min(current + 1, total)}
      aria-label={label ?? `Passo ${current + 1} de ${total}`}
      {...rest}
    >
      {steps.map((i) => (
        <span
          key={i}
          data-active={i <= current || undefined}
          className={cn(styles.bar, i <= current && styles.barActive)}
        />
      ))}
    </div>
  );
}
